import GlobalDispatchMethods from "./page/context/globalDispatchMethods";

const globalReducer = (state, action) => {
  switch (action.type) {
    case GlobalDispatchMethods.AddNotification:
      return addNotification(state, action);
    case GlobalDispatchMethods.RemoveNotification:
      return removeNotification(state, action);
    case GlobalDispatchMethods.ResetInitialState:
      return resetInitialState(state);
    case GlobalDispatchMethods.SetInitialState:
      return setInitialState(state, action);
    case GlobalDispatchMethods.SetSitemap:
      return setSitemap(state, action);
    case GlobalDispatchMethods.SitemapReset:
      return sitemapReset(state);
    case GlobalDispatchMethods.ToggleSideBar:
      return toggleNavigation(state);
    default:
      return state;
  }
};

const addNotification = (state, action) => {
  const notificationId = state.notificationId + 1;
  action.notification.id = notificationId;

  setTimeout(() => {
    action.dispatch({
      type: GlobalDispatchMethods.RemoveNotification,
      id: notificationId,
    });
  }, 5000);

  return {
    ...state,
    notifications: [...state.notifications, action.notification],
    notificationId: notificationId,
  };
};

const removeNotification = (state, action) => {
  const updatedNotifications = state.notifications.filter(
    (notification) => notification.id !== action.id
  );

  return {
    ...state,
    notifications: updatedNotifications,
  };
};

const resetInitialState = (state) => {
  return {
    ...state,
    initialStateBound: false,
  };
};

const setInitialState = (state, action) => {
  const {
    config,
    organisation,
    sitemap,
    slot,
    user,
    version,
    workspaceId,
  } = action.initialState;
  return {
    ...state,
    config: config,
    initialStateBound: true,
    organisation: organisation,
    sitemap: sitemap,
    slot: slot,
    user: user,
    version: version,
    workspaceId: workspaceId,
  };
};

const setSitemap = (state, action) => {
  return {
    ...state,
    sitemap: action.sitemap,
    initialStateBound: false,
    resetSitemap: true,
  };
};

const sitemapReset = (state) => {
  return {
    ...state,
    resetSitemap: false,
  };
};

const toggleNavigation = (state) => {
  const showNavigation = !state.showNavigation;
  localStorage.setItem("showNavigation", showNavigation);
  return {
    ...state,
    showNavigation: showNavigation,
  };
};

export { globalReducer };
